import axios from 'axios';
import store from '../store';
import { SnackbarProgrammatic as Snackbar } from 'buefy';

import { AUTH_LOGOUT } from '../store/actions/auth';

const api = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_URL}/api/`,
});

api.interceptors.response.use(
  (request) => request,
  (error) => {
    const { response, config } = error;
    if (!config.url.includes('login') && response && response.status === 401) {
      snackbarSession();
      store.dispatch(AUTH_LOGOUT);
    }
    return Promise.reject(error);
  }
);

const snackbarSession = () => {
  Snackbar.open('Sua sessão expirou. Realize login novamente para continuar.');
};

export default api;
